import React from 'react';

export default function Contact({ band }) {
    return (
        <section id="contact" className=" text-white py-16">
            <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
                <div>
                    <h1 className="text-2xl font-bold">Nous contacter</h1>
                    <h2 className="mt-2 text-indigo-100"><br></br>palladium.off.contact@gmail.com</h2>
                </div>
            </div>
        </section>
    );
}